function initializeLoader() {
  const loader = document.querySelector('.loader');
  const lottiePlayer = document.querySelector('.loader__lottie');

  if (!loader || !lottiePlayer) return; // Exit early if elements don't exist

  let animationStarted = false;
  let animationCompleted = false;

  // Add class to disable scrolling only when loader exists
  document.body.classList.add('loader-active');

  // Helper function to force reflow for Safari compatibility
  function forceReflow(element) {
    element.offsetHeight;
  }

  // Function to fade out and hide the loader
  function fadeOutLoader() {
    if (animationCompleted) return; // Prevent multiple calls
    animationCompleted = true;

    // Set up transition properties
    loader.style.transition = 'opacity 600ms ease';

    // Force reflow to ensure Safari processes the transition
    forceReflow(loader);

    loader.style.opacity = '0';

    // Hide loader after transition completes
    const handleTransitionEnd = () => {
      loader.style.display = 'none';
      loader.removeEventListener('transitionend', handleTransitionEnd);

      // Enable scrolling by removing the class
      document.body.classList.remove('loader-active');
    };

    loader.addEventListener('transitionend', handleTransitionEnd);
  }

  // Function to start animation
  function startAnimation() {
    if (animationStarted) return;
    animationStarted = true;

    console.log('Starting Lottie animation'); // Debug log
    lottiePlayer.play();

    // Listen for when the animation completes
    lottiePlayer.addEventListener('complete', () => {
      console.log('Lottie animation completed'); // Debug log
      fadeOutLoader();
    });
  }

  // Try multiple events to ensure animation starts
  lottiePlayer.addEventListener('load', () => {
    console.log('Lottie load event fired'); // Debug log
    startAnimation();
  });

  lottiePlayer.addEventListener('ready', () => {
    console.log('Lottie ready event fired'); // Debug log
    // Small delay to ensure it's really ready
    setTimeout(() => {
      startAnimation();
    }, 100);
  });

  // Fallback: if nothing else works, try after a short delay
  setTimeout(() => {
    console.log('Fallback timer - checking if animation started'); // Debug log
    if (!animationStarted) {
      startAnimation();
    }
  }, 1000);

  // Final fallback: if animation doesn't complete within 15 seconds, exit anyway
  setTimeout(() => {
    console.log('Final fallback - forcing exit'); // Debug log
    if (!animationCompleted) {
      fadeOutLoader();
    }
  }, 15000);
}

// Initialize loader when DOM is ready
document.addEventListener('DOMContentLoaded', initializeLoader);
